import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/index.js';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { reactReduxFirebaseConfig } from './config/ReactReduxFirebase.config';
import { createFirestoreInstance } from 'redux-firestore'
import { withStyles } from '@material-ui/styles';
import { styles } from './appContainer/layout/Layout.styles';
import { theme } from './appContainer/layout/Layout.theme';
import AppRouting from './AppRouting';

import './App.css';

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ReactReduxFirebaseProvider
          firebase={firebase}
          config={reactReduxFirebaseConfig}
          dispatch={store.dispatch}
          createFirestoreInstance={createFirestoreInstance}
        >
          <AppRouting/>
        </ReactReduxFirebaseProvider>
      </Provider>
    );
  }
}

export default (
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(App));
